import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

const MobiControl  = function(props){
    const blockKeys = Object.keys(props.blocks || {});
    const childBlocks = _.values(props.blocks || {}).map((Block, id) => {
        const BlockComponent = Block.component;
        return <BlockComponent context={props.context} openJSEditor={props.openJSEditor} key={blockKeys[id]} />; // NOSONAR: dynamic component resolved from block config data, consistent with the `<Block.component>` pattern used throughout blockVersions/
    });
    
    if (childBlocks.length > 0) {
        return (
            <category name='MobiControl' id='mobicontrol' iconclass='category with-icon-paths snap-icon-SOTI_Mobicontrol'>
                <label text={"MobiControl"}/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

MobiControl.propTypes = {
    context: PropTypes.object,
    blocks: PropTypes.object,
    openJSEditor: PropTypes.func
};

export default MobiControl